(() => {
  const form = document.getElementById('TradeContact');
  const messagesNode = document.getElementById('TradeMessages');
  if (!form || !messagesNode || form.dataset.initialized) return;
  form.dataset.initialized = 'true';
  const messages = JSON.parse(messagesNode.textContent);
  const storageKey = 'elite-trade-enquiry-v1';
  const readDraft = () => { try { return JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch { return null; } };
  const clearDraft = () => { try { sessionStorage.removeItem(storageKey); } catch {} };
  if (form.querySelector('[data-trade-success]')) {
    clearDraft();
    form.querySelector('[data-trade-success]').focus();
    return;
  }
  const interest = document.getElementById('TradeInterest');
  const cards = [...document.querySelectorAll('.trade-card')];
  const prompt = document.getElementById('TradePrompt');
  const hint = document.getElementById('TradeHint');
  const fields = [...form.querySelectorAll('input:not([type=hidden]), select, textarea')];
  const feedback = form.querySelector('.trade-feedback');
  const submit = form.querySelector('[type=submit]');
  const draft = readDraft();
  if (draft && Date.now() - draft.savedAt < 2 * 60 * 60 * 1000) {
    for (const field of fields) if (typeof draft.values?.[field.name] === 'string') field.value = draft.values[field.name];
    for (const field of form.querySelectorAll('[data-tracking]')) if (typeof draft.tracking?.[field.dataset.tracking] === 'string') field.value = draft.tracking[field.dataset.tracking];
  } else clearDraft();
  const params = new URLSearchParams(location.search);
  for (const field of form.querySelectorAll('[data-tracking]')) {
    if (params.has(field.dataset.tracking)) field.value = params.get(field.dataset.tracking).slice(0, 250);
  }
  const saveDraft = () => {
    const values = Object.fromEntries(fields.map(field => [field.name, field.value]));
    const tracking = Object.fromEntries([...form.querySelectorAll('[data-tracking]')].map(field => [field.dataset.tracking, field.value]));
    try { sessionStorage.setItem(storageKey, JSON.stringify({ values, tracking, savedAt: Date.now() })); } catch {}
  };
  const sync = () => {
    const option = interest.selectedOptions[0];
    for (const card of cards) card.setAttribute('aria-pressed', String(card.dataset.interest === option?.dataset.key));
    prompt.textContent = option?.dataset.prompt || messages.prompt;
    hint.textContent = option?.dataset.hint || messages.hint;
  };
  const validate = field => {
    let error = '';
    if (field.required && !field.value.trim()) error = messages.required;
    else if (!field.validity.valid) error = field.type === 'email' ? messages.email : messages.required;
    const target = document.getElementById(`${field.id}Error`);
    if (target) target.textContent = error;
    field.setAttribute('aria-invalid', String(Boolean(error)));
    return !error;
  };
  for (const card of cards) card.addEventListener('click', () => {
    interest.value = [...interest.options].find(option => option.dataset.key === card.dataset.interest).value;
    sync();
    if (interest.getAttribute('aria-invalid') === 'true') validate(interest);
    saveDraft();
  });
  interest.addEventListener('change', () => { sync(); validate(interest); saveDraft(); });
  for (const field of fields) {
    field.addEventListener('input', () => { if (field.getAttribute('aria-invalid') === 'true') validate(field); saveDraft(); });
    field.addEventListener('blur', () => { if (field.value || field.getAttribute('aria-invalid') === 'true') validate(field); });
  }
  form.addEventListener('invalid', event => {
    event.preventDefault();
    validate(event.target);
    feedback.textContent = messages.validation;
    queueMicrotask(() => form.querySelector('[aria-invalid="true"]')?.focus());
  }, true);
  let pending = false;
  let timer;
  form.addEventListener('submit', event => {
    if (event.defaultPrevented) return;
    if (pending) { event.preventDefault(); return; }
    const invalid = fields.filter(field => !validate(field));
    if (invalid.length) {
      event.preventDefault();
      feedback.textContent = messages.validation;
      invalid[0].focus();
      return;
    }
    saveDraft();
    pending = true;
    feedback.textContent = messages.sending;
    form.setAttribute('aria-busy', 'true');
    submit.disabled = true;
    timer = setTimeout(() => {
      feedback.textContent = messages.uncertain;
      form.removeAttribute('aria-busy');
      submit.disabled = false;
      pending = false;
    }, 45000);
  });
  window.addEventListener('pageshow', () => {
    if (pending) {
      clearTimeout(timer);
      pending = false;
      submit.disabled = false;
      form.removeAttribute('aria-busy');
      feedback.textContent = '';
    }
  });
  sync();
  const serverError = form.querySelector('.trade-server-error');
  if (serverError) serverError.focus();
})();
